import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
          漫画分类
        </h2>
        <Link
          to="/category/all"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap"
        >
          查看全部
          <span className="ml-1">
            <div className="w-4 h-4 inline-flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </span>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.filter(c => c.id !== 'all').map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex flex-col items-center justify-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer group"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}